// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import ContractorTaxInformationReduxForm from '../layout/reduxForm/ContractorTaxInformation';
import ControlButtonsSection from '../layout/reduxForm/section/contractorTaxInformation/ControlButtonsSection';
import onSubmit from '../../utils/reduxForm/onSubmit/contractorTaxInformation';

const ContractorTaxInformationModal = ({ modalState, toggleModal }) => {
    const closeModal = () => {
        toggleModal(!modalState.isOpen, 'contractorTaxInformationModal');
    };

    if (!modalState.isOpen) return null;

    return (
        <div
            className="modal_block dashboard-modal dashboard-modal--centered certification_modal showed"
            role="presentation"
            onClick={closeModal}
        >
            <div
                className="modal_container"
                role="dialog"
                aria-modal="true"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="close_btn icon_close certification_modal__close"
                    aria-label="close"
                    onClick={closeModal}
                />

                <div className="inner_container">
                    <span className="filter_shadow top_shadow"></span>

                    <div className="modal_head">
                        <div className="modal_title">
                            Request for Taxpayer Identification Number and Certification
                        </div>
                        <div className="modal_subtitle">
                            The following information is required by law to report your
                            earnings to the IRS.&nbsp;The Tax Identification Number will be
                            used solely for this purpose.&nbsp;You must provide a Tax
                            Identification Number in order to withdraw funds from your&nbsp;
                            account. For instructions on filling out this form please see the&nbsp;
                            <a href="https://www.irs.gov/pub/irs-pdf/fw9.pdf">
                                official IRS Form W-9.
                            </a>
                        </div>
                    </div>

                    <div className="modal_body">
                        <ContractorTaxInformationReduxForm onSubmit={onSubmit} />
                    </div>

                    <span className="filter_shadow bottom_shadow"></span>
                </div>

                <div className="modal_footer">
                    <ControlButtonsSection closeModal={closeModal} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    modalState: state.modalState.contractorTaxInformationModal,
});

export default connect(mapStateToProps, { toggleModal })(ContractorTaxInformationModal);
